import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["PlatformApplicationForm"] */ "/app/src/components/pages/(main)/platform/PlatformApplicationForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlatformScripts"] */ "/app/src/components/script-blocks/PlatformScripts.tsx");
